import hash from 'object-hash';
import memoize from 'memoizee';
export const hashRequest = memoize((request) => hashObject(request), { maxAge: 2000 });
export const areRequestsEqual = (requestA, requestB) => hashRequest(requestA) === hashRequest(requestB);
const hashObject = (object) => hash(object, { algorithm: 'md5', unorderedArrays: true });
